module.exports = __webpack_public_path__ + "img/makeing.b6204695.svg";